import { Footer } from "../components/Footer"
import { PayoutP2PMethods } from "../components/payout/PayoutP2PMethods"


export const PayoutP2PPage = () => {
    return (
        <div className="container">
            <PayoutP2PMethods />
            <Footer />
        </div>
    );
}